function triple_min(a, b, c) {
    const temp = a < b ? a : b;
    return temp < c ? temp : c;
}

// ----------------------------
// BK-tree TNode definition
// ----------------------------

// Maxium word length
const LEN = 1024;

function TNode(w) {
    this.word = w;
    this.next = new Array(2 * LEN);
    for (let i = 0; i < 2 * LEN; i++) {
        this.next[i] = -1;
    }
}

TNode.prototype.setWord = function setWord(w) {
    this.word = w;
};


class BurkHardKellerAutoSuggestion {
    constructor(word_num) {
        this.tree = new Array(word_num);
        for (let i = 0; i < this.tree.length; i++) {
            this.tree[i] = new TNode("");
        }
        this.root = new TNode("");
        this.ptr = 0;
    }
    addWord(idx, curr) {
        if (this.root.word === "") {
            this.root.setWord(curr.word);
            this.tree[0] = this.root;
            return;
        }
        const dist = DistanceBtwTwoStrings.compare(this.root.word, curr.word);
        if (this.tree[idx].next[dist] === -1) {
            this.ptr++;
            this.tree[this.ptr].setWord(curr.word);
            this.tree[idx].next[dist] = this.ptr;
        } else {
            this.addWord(this.tree[idx].next[dist], curr);
        }
    }
    getAutoSuggestionWordsUtil(idx, word, TOL) {
        let ret = [];
        if (idx === -1) return ret;
        if (this.root.word === "") return ret;
        const cur_rt = this.tree[idx];
        const dist = DistanceBtwTwoStrings.compare(word, cur_rt.word);
        if (dist <= TOL) ret.push(cur_rt.word);
        let start = dist - TOL;
        if (start < 0) start = 1;
        const end = dist + TOL;
        while (start < end) {
            const temp = this.getAutoSuggestionWordsUtil(cur_rt.next[start], word, TOL);
            ret = ret.concat(temp);
            start++;
        }
        return ret;
    }
    add(words) {
        if (!Array.isArray(words)) {
            throw new Error("words is not array");
        }
        words.forEach((element) => {
            this.addWord(0, new TNode(element));
        });
    }

    getAutoSuggestionWords(src, TOL) {
        return this.getAutoSuggestionWordsUtil(0, src, TOL);
    }
}
